export const PRACTITIONER_PREFERENCES_LIST_REQUEST = 'PRACTITIONER_PREFERENCES_LIST_REQUEST';
export const PRACTITIONER_PREFERENCES_LIST_SUCCESS = 'PRACTITIONER_PREFERENCES_LIST_SUCCESS';
export const PRACTITIONER_PREFERENCES_LIST_FAIL = 'PRACTITIONER_PREFERENCES_LIST_FAIL';

export const PRACTITIONER_PREFERENCES_DETAILS_REQUEST = 'PRACTITIONER_PREFERENCES_DETAILS_REQUEST';
export const PRACTITIONER_PREFERENCES_DETAILS_SUCCESS = 'PRACTITIONER_PREFERENCES_DETAILS_SUCCESS';
export const PRACTITIONER_PREFERENCES_DETAILS_FAIL = 'PRACTITIONER_PREFERENCES_DETAILS_FAIL';
export const PRACTITIONER_PREFERENCES_DETAILS_RESET = 'PRACTITIONER_PREFERENCES_DETAILS_RESET';

export const PRACTITIONER_PREFERENCES_CREATE_REQUEST = 'PRACTITIONER_PREFERENCES_CREATE_REQUEST';
export const PRACTITIONER_PREFERENCES_CREATE_SUCCESS = 'PRACTITIONER_PREFERENCES_CREATE_SUCCESS';
export const PRACTITIONER_PREFERENCES_CREATE_FAIL = 'PRACTITIONER_PREFERENCES_CREATE_FAIL';
export const PRACTITIONER_PREFERENCES_CREATE_RESET = 'PRACTITIONER_PREFERENCES_CREATE_RESET';

export const PRACTITIONER_PREFERENCES_UPDATE_REQUEST = 'PRACTITIONER_PREFERENCES_UPDATE_REQUEST';
export const PRACTITIONER_PREFERENCES_UPDATE_SUCCESS = 'PRACTITIONER_PREFERENCES_UPDATE_SUCCESS';
export const PRACTITIONER_PREFERENCES_UPDATE_FAIL = 'PRACTITIONER_PREFERENCES_UPDATE_FAIL';
export const PRACTITIONER_PREFERENCES_UPDATE_RESET = 'PRACTITIONER_PREFERENCES_UPDATE_RESET';

export const PRACTITIONER_PREFERENCES_DELETE_REQUEST = 'PRACTITIONER_PREFERENCES_DELETE_REQUEST';
export const PRACTITIONER_PREFERENCES_DELETE_SUCCESS = 'PRACTITIONER_PREFERENCES_DELETE_SUCCESS';
export const PRACTITIONER_PREFERENCES_DELETE_FAIL = 'PRACTITIONER_PREFERENCES_DELETE_FAIL';

export const PRACTITIONER_PREFERENCES_DTO_REQUEST = 'PRACTITIONER_PREFERENCES_DTO_REQUEST';
export const PRACTITIONER_PREFERENCES_DTO_SUCCESS = 'PRACTITIONER_PREFERENCES_DTO_SUCCESS';
export const PRACTITIONER_PREFERENCES_DTO_FAIL = 'PRACTITIONER_PREFERENCES_DTO_FAIL';
export const PRACTITIONER_PREFERENCES_DTO_RESET = 'PRACTITIONER_PREFERENCES_DTO_RESET';

export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'; 